import { forwardRef } from 'react';
import type { TextStyleValue } from '@elfsight/configurator-contracts';
import { calculatePadding } from './calculatePadding';
import type {
  TextControlBaseInstance,
  TextControlBaseProps
} from './TextControlBase';
import { TextControlBase } from './TextControlBase';

export type TextControlProps = TextControlBaseProps & {
  font?: TextStyleValue;
  labelFont?: TextStyleValue;
  mask?: string;
  forceFocusAnimation?: boolean;
  shouldFocusSlotOnClick?: boolean;
  specialEmptyCase?: string;
};

export const TextControl = forwardRef<
  TextControlBaseInstance,
  TextControlProps
>(function TextControl(
  {
    font = { fontSize: 16 },
    labelFont = { fontSize: 16 },
    padding: derivedPadding,
    label,
    leftSlot,
    rightSlot,
    background,
    borderType,
    ...forwardingProps
  },
  forwardingRef
) {
  const { fontWeight, fontStyle, fontSize } = font;
  const {
    fontWeight: labelFontWeight,
    fontStyle: labelFontStyle,
    fontSize: labelFontSize,
    textTransform: labelTextTransform
  } = labelFont;

  const withLabel = !!label;
  const iconPosition =
    (!!leftSlot && 'left') || (!!rightSlot && 'right') || false;
  const underlineMode =
    borderType === 'underline' && (background === 'transparent' || !background);

  const currentPadding =
    derivedPadding ||
    calculatePadding(fontSize, withLabel, iconPosition, underlineMode);

  return (
    <TextControlBase
      {...forwardingProps}
      ref={forwardingRef}
      padding={currentPadding}
      fontWeight={fontWeight}
      fontStyle={fontStyle}
      fontSize={fontSize}
      background={background}
      borderType={borderType}
      label={label}
      labelFontStyle={labelFontStyle}
      labelFontWeight={labelFontWeight}
      labelFontSize={labelFontSize}
      labelTextTransform={labelTextTransform}
      leftSlot={leftSlot}
      rightSlot={rightSlot}
    />
  );
});
